module.exports = __webpack_public_path__ + "img/outlook.c1dc224c.png";